var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMsr = function SvgMsr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M334.222 191.996v78.221c0 38.103 49.777 49.779 49.777 49.779s49.778-11.675 49.778-49.779v-78.221h-99.555z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M334.222 270.217c0 38.103 49.777 49.779 49.777 49.779s49.778-11.675 49.778-49.779h-99.555z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M405.334 227.552H391.11v-14.223h-14.222v14.223h-14.222v14.223h14.222v42.665h14.222v-42.665h14.224z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.174 140.982L0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  })));
};
export { SvgMsr as ReactComponent };